'use strict';

const IsotopicDistribution = require('./IsotopicDistribution');

module.exports = IsotopicDistribution;



// WEBPACK FOOTER //
// ../isotopic-distribution/src/index.js